import React from "react";
import Modal from "../../../containers/Modal";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function ShowFacilitatorModal({isOpen, close, theme, data}) {
   if (!data) return null;
   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         // confirm={true}
         theme={theme}
         title="información de Facilitador"
      >
         <DivModal>
            <div>
               <Grid>
                  <Col large="5">
                     <Label className="textModal">Nombre:</Label>
                     <Label className="labelText">{data.name}</Label>
                  </Col>
                  {/* <Col large="4" /> */}
                  <Col large="5">
                     <Label className="textModal">Especialidad:</Label>
                     <Label className="labelText">{data.especiality}</Label>
                  </Col>
                  <Col large="2" />
                  <Col large="12">
                     <Label className="textModal">Biografía:</Label>
                     <Label className="labelText">{data.bio}</Label>
                  </Col>
                  <Col large={9} className="section maxMargin">
                     <EditableImg
                        title="Imagen Página Facilitadores"
                        name={`imgMobile${data.id}`}
                        fileName={data.pathImageWebDesktop}
                        label="Mobile medidas aprox 510px x 700"
                        editable={false}
                     />
                  </Col>
                  <Col large={12} className="section maxMargin">
                     <Label className="title">Imágenes:</Label>
                     <Grid>
                        <EditableImg
                           title="Desktop"
                           name={`imgDesk${data.id}`}
                           fileName={data.pathImageBioDesktop}
                           label="Desktop medida aprox 1024px x 845px"
                           editable={false}
                        />
                        <EditableImg
                           title="Mobile"
                           name={`imgMobile${data.id}`}
                           fileName={data.pathImageBioMobile}
                           label="Mobile medidas aprox 510px x 700"
                           editable={false}
                        />
                     </Grid>
                  </Col>
               </Grid>
            </div>
         </DivModal>
      </Modal>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
   .maxMargin {
      margin-top: 2em;
   }
`;
